<template>
  <div id="order">
    <section class="main-box-left">
      <order-info v-if="step === 1"></order-info>
      <cart v-else></cart>
    </section>
    <section class="main-box-right">
      <order-action></order-action>
    </section>
    <NewCusDialog v-model:visible="showJoinMemberDialog" title="尚未加入電話會員" :hide-close="true" width="500">
      <template #body>
        <div class="join-member-dialog-body">
          <p>請問顧客是否要現在加入電話會員？</p>
        </div>
      </template>
      <template #footer>
        <div class="join-member-dialog-footer">
          <cus-button
            text="取消"
            color="white"
            :width="50"
            :disabled="isButtonDisabled"
            @click="handleCancelClick"
          ></cus-button>
          <cus-button
            text="確定"
            color="blue"
            :width="50"
            :disabled="isButtonDisabled"
            @click="handleConfirmClick"
          ></cus-button>
        </div>
      </template>
    </NewCusDialog>
  </div>
</template>

<script setup>
import { defineAsyncComponent, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import NewCusDialog from '../library/NewCusDialog.vue';
import { useActions } from '@/utils/mapStore';

const OrderInfo = defineAsyncComponent(() => import('@/components/order/left/OrderInfo.vue'));
const OrderAction = defineAsyncComponent(() => import('@/components/order/right/OrderAction.vue'));
const Cart = defineAsyncComponent(() => import('@/components/order/left/Cart.vue'));

const store = useStore();
const step = computed(() => store.getters['order/getStep']);
const showJoinMemberDialog = computed(() => store.getters['member/getShowJoinDialog']);
const doSetPhoneMemberIntoOrder = useActions('member', ['doSetPhoneMemberIntoOrder']);
const doQueryMemberInfoByPhone = useActions('member', ['doQueryMemberInfoByPhone']);
const doCloseJoinDialog = useActions('member', ['doCloseJoinDialog']);
const isButtonDisabled = ref(false);

const handleRegister = async (isAutoRegister) => {
  try {
    const data = await doSetPhoneMemberIntoOrder(isAutoRegister);
    if (isAutoRegister && data?.is_create_success) {
      const order_id = store.getters['order/getOrderId'];
      const cell_phone = store.getters['member/getMemberPhone'];
      await doQueryMemberInfoByPhone({ order_id, cell_phone });
    }
  } catch (error) {
    console.error('handleRegister isButtonDisabled.value', isButtonDisabled.value);
  }
  await doCloseJoinDialog();
};

const debounce = (fn, delay = 3000) => {
  return () => {
    if (isButtonDisabled.value) return;
    isButtonDisabled.value = true;

    fn();

    setTimeout(() => {
      isButtonDisabled.value = false;
    }, delay);
  };
};

const handleCancelClick = debounce(() => handleRegister(false));
const handleConfirmClick = debounce(() => handleRegister(true));
</script>

<style lang="scss" scoped>
.main-box-right {
  grid-template-rows: $content-main $content-button auto;
}
.join-member-dialog-body {
  font-size: 2.4rem;
  width: 100%;
  text-align: center;
  padding: 20px 0;
}
.join-member-dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
